import menuUI from './menus/ui.menu'
import menuApps from './menus/apps.menu'
import menuPages from './menus/pages.menu'

export default {
  // main navigation - side menu
  menu: [
    {
      text: '',
      key: '',
      items: [
        {
          icon: 'mdi-view-dashboard-outline',
          text: 'Dashboard',
          link: '/dashboard/analytics'
        }
      ]
    },
    {
      text: 'Campañas',
      items: [
        { icon: 'mdi-bullhorn', text: 'Campañas', link: '/services' },
        {
          icon: 'mdi-chart-line',
          text: 'Reportería',
          items: [
            { text: 'Campañas', link: '/reports/campaigns' },
            { text: 'Consumos', link: '/reports/registers' }
          ]
        }
      ]
    },{
      text: 'Atención al cliente',
      key: '',
      items: [
        {
          icon: 'mdi-headset',
          text: 'Atención al cliente',
          items: [
            { text: 'Configuración', link: '/management/workgroups' },
            { text: 'Supervisar', link: '/management/supervisor' }
            //{ text: 'Hipervision', link: '/management/hipervisor' },
            //{ text: 'Permisos de Meta', link: '/management/mm_lite_onboarding' } 
            //https://b03a-2001-1388-ae1-1e4c-2109-4777-df88-8787.ngrok-free.app/api/meta_marketing_onboarding/' + companyId
          ]
        }
      ]
    },
    {
      text: 'Herramientas',
      key: '',
      items: [
        { icon: 'mdi-file-image', text: 'Archivos', link: '/tools/filescloud' },
        { icon: 'mdi-link-plus', text: 'URL', link: '/tools/shorturl' },
        { icon: 'mdi-contacts', text: 'Agendas', link: '/tools/agendas' },
        { icon: 'mdi-block-helper', text: 'Lista negra', link: '/tools/blacklist' }
      ]
    },
    {
      text: 'Chat',
      key: '',
      items: [
        { icon: 'mdi-message', text: 'Chat', link: '/agent/tools/chat' }
      ]
    },
    {
      text: 'Configuración',
      key: '',
      items: [
        {
          icon: 'mdi-account-group',
          text: 'Usuarios',
          link: '/config/users'
        }
      ]
    },
    {
      text: 'Canales',
      key: '',
      items: [
        {
          icon: 'mdi-send',
          text: 'Senders',
          link: '/channels/senders'
        },
        {
          icon: 'mdi-call-split',
          text: 'Proveedores',
          link: '/channels/vendors'
        }
      ]
    },
    {
      text: 'Soporte',
      key: '',
      items: [
        {
          icon: 'mdi-call-split',
          text: 'Flows',
          link: '/support/flows'
        }/* ,
        {
          icon: 'mdi-call-split',
          text: 'TEST COMPONENT',
          link: '/testing'
        } */
      ]
    },
    {
      text: 'Documentación',
      items: [
        {
          icon: 'mdi-file-document',
          text: 'Documentación Api',
          link: '/enviamas-documentation'
        }
      ]
    },
    {
      text: 'Otros',
      key: '',
      items: [
        {
          icon: 'mdi-call-split',
          text: 'Bots',
          link: '/bots'
        },
        {
          icon: 'mdi-call-split',
          text: 'Compañias',
          link: '/companies'
        }
      ]
    }
  ]
}
